import { useLoading } from '../../utils/LoadingProvider';
import { getSocket } from '../../services/socket';
import { whatsappApi } from '../../services/api';
import React, { useState, useEffect, useRef } from 'react';
import { ChatUsuario, MensajeUsuario } from '../../objetos/Whatsapp/objeto_whatsapp';
import { n8nApiWebhook } from '../../services/apin8n';
import { useRetornoAsesor } from '../../config/unificacion';

export const useWhatsappComercialModel = () =>{
    const {withLoading } = useLoading();
    
    //chats
    const [usuarios, setusuarios] = useState([]);
    const [loadingUsuarios, setloadingUsuarios] = useState();
    const [errorUsuarios, seterrorUsuarios] = useState();
    //id usuario actualizado
    const [idChatActualizado, setIdChatActualizado] = useState(null);

    //mensajes
    const [mensajes, setmensajes] = useState([]);
    const [loadingmensajes, setloadingmensajes] = useState();
    const [errormensajes, seterrormensajes] = useState();

    //retornar asesor
    const {retornoAsesor} = useRetornoAsesor();
    const cambiadopor = retornoAsesor();

    //referencias
    const chatActivoIdRef = useRef(null);

    //cargar todos los usuarios
    const cargarTodosLosUsuarios = async(nombreEmpresa,estaArchivado) =>{
        try{
            setloadingUsuarios(true);
            seterrorUsuarios(null);

            const response = await whatsappApi.getChats(nombreEmpresa,estaArchivado);
            const data = response.data;
            const chat_usuario_obj = data.map(chatData => ChatUsuario.fromJson(chatData));
            
            console.log("chats",chat_usuario_obj);
            setusuarios(chat_usuario_obj);
        }
        catch(error){
            seterrorUsuarios('Error al cargar los usuarios' + error.message);
        }finally{
            setloadingUsuarios(false);
        }
    }

    //cargar todos los mensajes
    const cargarTodosLosMensajes = async(nombreEmpresa,numero) =>{
        chatActivoIdRef.current = numero;

        try{
            setloadingmensajes(true);
            seterrormensajes(null);

            const response = await whatsappApi.getMensajes(nombreEmpresa,numero);
            const data = response.data;
            const mensaje_usuario_obj = data.map(chatData => MensajeUsuario.fromJson(chatData));

            setmensajes(mensaje_usuario_obj);
        }
        catch(error){
            seterrormensajes('Error al cargar los mensajes' + error.message)
        }
        finally{
            setloadingmensajes(false);
        }
    }

    //enviar mensaje
    const enviarMensaje = async(telefono,mensaje,archivosEnvio) =>{
        try{
            let tipoMensaje = "text";
            const archivo = archivosEnvio ? archivosEnvio.archivo : null;

            if(archivo) {
                const tipoMIME = archivo.type; // Ej: "image/png", "application/pdf", "video/mp4"

                if (tipoMIME.startsWith('image/')) {
                    tipoMensaje = "image";
                } else if (tipoMIME.startsWith('video/')) {
                    tipoMensaje = "video";
                } else if (tipoMIME.startsWith('audio/')) {
                    tipoMensaje = "audio";
                } else {
                    tipoMensaje = "document";
                }
            }

            const response = await n8nApiWebhook.envioMensaje(telefono,mensaje,tipoMensaje,archivo,cambiadopor);

            //feedback de response
            console.log("Respuesta de la API:", response);
        }
        catch(error){
            console.error('Error al enviar mensaje:', error);
            throw error;
        }
    }

    //update usuario label
    const updateUsuario = async(phone_number, field,  newValue  ) =>{
        try{
            console.log("tenemos update usuario",phone_number,newValue);

            const response = await whatsappApi.updateUsuario(phone_number,newValue,field);

        }
        catch(error){
            console.error('Error al actualizar usuario:', error);
            throw error;
        }
    }

    //sockets
    // --- Lógica de Sockets en un único useEffect ---
    useEffect(() => {
        const nombreEmpresa = "DUFY ASESORIAS"; // O tómalo de un contexto/prop
        const socket = getSocket();

        console.log("usuarios anteriores",usuarios);

        // Handler para cuando la conexión es exitosa
        const onConnect = () => {
            console.log(`Socket conectado a WhatsApp. Suscribiendo a ${nombreEmpresa}...`);
            socket.emit('subscribe_to_company', nombreEmpresa);
        };

        // Handler para las actualizaciones de usuario
        const handleUserUpdate = (usuarioActualizadoPayload) => {
            console.log("✅ Actualización de usuario recibida:", usuarioActualizadoPayload);
            
            const usuarioNormalizado = ChatUsuario.fromJson(usuarioActualizadoPayload);
            setIdChatActualizado(usuarioNormalizado.phone_number);

            setusuarios(usuariosAnteriores => {
                let usuariosNuevos;
                const indiceUsuario = usuariosAnteriores.findIndex(u =>
                    u.phone_number === usuarioNormalizado.phone_number &&
                    u.company_name === usuarioNormalizado.company_name
                );

                if (indiceUsuario !== -1) {
                    // Si el usuario existe, crea una copia y lo actualiza
                    usuariosNuevos = [...usuariosAnteriores];

                    const clienteInfoPreservada = usuariosAnteriores[indiceUsuario].clienteInfo;

                    if (clienteInfoPreservada) {
                        usuarioNormalizado.clienteInfo = clienteInfoPreservada;
                    }

                    usuariosNuevos[indiceUsuario] = usuarioNormalizado;


                } else {
                    // Si es nuevo, lo añade a la lista
                    usuariosNuevos = [usuarioNormalizado, ...usuariosAnteriores];
                }

                // ✨ CORRECCIÓN: Ordena la lista COMPLETA aquí, después de cualquier modificación.
                return usuariosNuevos.sort((a, b) => 
                    new Date(b.last_message_timestamp) - new Date(a.last_message_timestamp)
                );
            });

        };

        //escuchar nuevos mensajes
        const handleNewMessage = (mensajePayload) =>{
            console.log("📨 Nuevo mensaje recibido:", mensajePayload);

            // Solo procesamos si el mensaje pertenece al chat que está actualmente abierto.
            if (mensajePayload.user_phone_number === chatActivoIdRef.current) {
                
                const nuevoMensaje = MensajeUsuario.fromJson(mensajePayload);

                setmensajes(mensajesAnteriores => {
                    // Buscamos si ya tenemos un mensaje con el mismo ID.
                    const indiceExistente = mensajesAnteriores.findIndex(m => m.id === nuevoMensaje.id);

                    if (indiceExistente !== -1) {
                        // Si el mensaje YA EXISTE (índice es 0 o mayor), lo actualizamos.
                        console.log(`Actualizando mensaje existente con ID: ${nuevoMensaje.id}`);
                        const mensajesActualizados = [...mensajesAnteriores]; // Creamos una copia
                        mensajesActualizados[indiceExistente] = nuevoMensaje; // Reemplazamos el elemento
                        return mensajesActualizados;
                    } else {
                        // Si el mensaje NO EXISTE, lo añadimos al final.
                        console.log(`Añadiendo nuevo mensaje con ID: ${nuevoMensaje.id}`);
                        return [...mensajesAnteriores, nuevoMensaje];
                    }
                });
            }

        }

        // Asignamos los listeners
        socket.on('connect', onConnect);
        socket.on('whatsapp_user_update', handleUserUpdate);
        socket.on('new_whatsapp_message', handleNewMessage);

        // Función de limpieza que se ejecuta cuando el componente se desmonta
        return () => {
            console.log("Limpiando listeners de socket de WhatsApp...");
            socket.off('connect', onConnect);
            socket.off('whatsapp_user_update', handleUserUpdate);
            socket.off('new_whatsapp_message', handleNewMessage);
        };
    }, []); 

    //suscripcion para salas de chat
    useEffect(() =>{
        const socket = getSocket();
        const companyName = "DUFY ASESORIAS";
        const phoneNumber = chatActivoIdRef.current;

        if (phoneNumber) {
            console.log(`[Socket.IO] Suscribiendo a la sala del usuario: ${phoneNumber}`);
            socket.emit('subscribe_to_user_messages', { phoneNumber, companyName });
        }

        return () => {
            if (phoneNumber) {
                console.log(`[Socket.IO] Desuscribiendo de la sala del usuario: ${phoneNumber}`);
                socket.emit('unsubscribe_from_user_messages', { phoneNumber, companyName });
            }
        };

    }, [mensajes]);
    

    return{
        //usuarios
        usuarios,
        idChatActualizado,
        setIdChatActualizado,
        loadingUsuarios,
        errorUsuarios,
        cargarTodosLosUsuarios,

        //mensajes
        mensajes,
        loadingmensajes,
        errormensajes,
        cargarTodosLosMensajes,

        //enviar mensaje
        enviarMensaje,

        //act usuario
        updateUsuario,

    }

}